import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getFeatureFlags } from 'utils/feature-flags';

/**
 * Applies the 'brand-world' class to the body tag when the
 * designSystem_brandWorldTypography feature flag is enabled.
 *
 * Once fully live, Brand World will become the default, and
 * both the feature flag and this component will be removed.
 */
export const BrandWorldSwitch = () => {
  const { designSystem_brandWorldTypography: brandWorldTypographyEnabled } = getFeatureFlags();

  if (!brandWorldTypographyEnabled) {
    return null;
  }

  return <Helmet bodyAttributes={{ class: 'brand-world' }} />;
};
